import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

export const ResendBanner = ({ onDone }) => {
  const [params, setParams] = useSearchParams();
  const [busy, setBusy] = useState(false);
  const id = params.get("resend");
  const kind = params.get("kind") === "request" ? "request" : "test";
  if (!id) return null;
  const close = () => setParams({}, { replace: true });
  const send = () => {
    setBusy(true);
    const url = kind === "test" ? `/admin/test-bookings/${encodeURIComponent(id)}/resend` : `/admin/payment-requests/${encodeURIComponent(id)}/send`;
    api.post(url).then(() => { toast.success("Payment link emailed to the patient again."); close(); onDone?.(); })
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message)).finally(() => setBusy(false));
  };
  return (
    <div data-testid="resend-banner" className="p-5 rounded-md border-2 border-bronze-dark bg-cream-100 flex flex-wrap items-center gap-4">
      <p className="flex-1 min-w-[220px]">Resend this {kind === "test" ? "test booking" : "payment"} link to the patient by email?</p>
      <button type="button" className="btn-primary" disabled={busy} onClick={send} data-testid="resend-confirm">{busy ? "Sending…" : "Resend link"}</button>
      <button type="button" className="text-sm underline" onClick={close} data-testid="resend-cancel">Cancel</button>
    </div>
  );
};
